import React, { useMemo } from 'react'

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withTheme } from 'styled-components'
import { v4 as uuid } from 'uuid'

import Icon, { IconNames } from 'components/icons'
import Input from 'components/input'
import e2eClasses from 'constants/e2eClasses'
import { isMobileOrTablet } from 'helpers/utils'
import NAMESPACES from 'localization/constants/namespaces'
import { mapMediaType } from 'selectors/mediaType'

import ConfigPassenger from '../config-passenger'
import {
  getConfigPassengerRadioGroupOptions,
  getConfigPassengersInputNumberValue
} from '../helpers'
import {
  ConferenceCodeContainer,
  ConferenceConfigPassengerWrapper,
  IconLabelWrapper,
  Label,
  ConfigPassengerContainer
} from '../styled'

const ConfigPassengerInput = ({
  cabins,
  availableCabins,
  isResearchBoxExpanded,
  mobileOrTablet,
  isResearch,
  theme,
  handlePassengersDataChange,
  conferenceCodeHandler,
  passengers,
  conferenceCode,
  isMultidestiny,
  passengersError,
  restrictions,
  isConference,
  campaignPropsAvailableCabins
}) => {
  const { t } = useTranslation(NAMESPACES.SEARCH_BOX)

  const showIcon = !isResearch && isMultidestiny
  const mobileNotMulti = mobileOrTablet && !isMultidestiny
  const desktopMultidestiny = !mobileOrTablet && isMultidestiny
  const desktopMultidestinyNotResearch = desktopMultidestiny && !isResearch
  const desktopOneDestiny = !isMultidestiny && isResearch
  const conferenceCodeValue = conferenceCode && conferenceCode.value
  const conferenceCodeError = conferenceCode && conferenceCode.error
  const inputId = useMemo(() => uuid(), [])

  const BaseComponentJSX = (
    <ConfigPassengerContainer
      orientationRow={desktopMultidestinyNotResearch}
      isConference={isConference}
      paddingBottom={
        desktopOneDestiny ? '0px' : (isConference || !desktopMultidestinyNotResearch) && '15px'
      }
      paddingTop={mobileOrTablet && '30px'}
    >
      <IconLabelWrapper hide={mobileNotMulti}>
        {showIcon && (
          <Icon
            name={IconNames.PassengerSeated}
            color={theme.colors.blue50}
            size={desktopMultidestinyNotResearch ? 25 : 20}
          />
        )}
        <Label
          e2eClass={e2eClasses.searchBox.passenger}
          boldBlue={showIcon}
          isResearch={isResearch}
          forId="cabin-passengers"
        >
          {t('shopping.search-box.class-passengers')}
        </Label>
      </IconLabelWrapper>
      <ConfigPassenger
        disableIndex={!isResearchBoxExpanded && isResearch}
        onChange={handlePassengersDataChange}
        radioGroupOptions={getConfigPassengerRadioGroupOptions(
          cabins,
          campaignPropsAvailableCabins,
          availableCabins,
          passengers
        )}
        inputsNumber={getConfigPassengersInputNumberValue(t, passengers)}
        error={passengersError}
        flatStyle={isResearch || isConference}
        fullWidth={!desktopMultidestinyNotResearch}
        restrictions={restrictions}
      />
    </ConfigPassengerContainer>
  )

  return isConference ? (
    <ConferenceConfigPassengerWrapper>
      <ConferenceCodeContainer>
        <Label
          e2eClass={e2eClasses.searchBox.code}
          boldBlue={showIcon}
          isResearch={isResearch}
          forId={inputId}
        >
          {t(`${NAMESPACES.EVENTS}:events.search-box.conference-code.label`)}
        </Label>
        <Input
          id={inputId}
          name={e2eClasses.searchBox.code}
          flatStyle
          placeholder={t(`${NAMESPACES.EVENTS}:events.search-box.conference-code.placeholder`)}
          onChange={conferenceCodeHandler}
          value={conferenceCodeValue || ''}
          error={conferenceCodeError}
        />
      </ConferenceCodeContainer>
      {BaseComponentJSX}
    </ConferenceConfigPassengerWrapper>
  ) : (
    BaseComponentJSX
  )
}
ConfigPassengerInput.propTypes = {
  isConference: PropTypes.bool,
  isResearch: PropTypes.bool,
  isCampaignRestricted: PropTypes.bool
}

const mapStateToProps = state => ({
  mobileOrTablet: isMobileOrTablet(mapMediaType(state))
})

export default connect(mapStateToProps)(withTheme(ConfigPassengerInput))
